import React from "react";
import "./footer.css";

export const Footer = () =>{
    return(
        <div className="Main-Footer">
            <p>&copy; 2024 BeeSimpleDesign</p>
        </div>
    )
}